import { render } from "./Toprated.vue?vue&type=template&id=6f3558aa&scoped=true"
import script from "./Toprated.vue?vue&type=script&lang=js"
export * from "./Toprated.vue?vue&type=script&lang=js"

import "./Toprated.vue?vue&type=style&index=0&id=6f3558aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f3558aa"

export default script